module.exports = __webpack_public_path__ + "static/battle_09-4f60c9ca5b6731b39c58dff702cb8f22.jpg";